// extracted by mini-css-extract-plugin
export default {"cardContainer":"DelotsCard_cardContainer__dmg0P"};